"use client";

import { Button, Icon } from "@cloai/uikit";
import Image from "next/image";
import { memo, SyntheticEvent } from "react";

import { cn } from "@/utils/cn";

import { PLATE_CLASSLIST } from "./vars";

interface DetailsCardProps {
  image: string;
  title: string;
  name: string;
  count?: number;
  isInit?: boolean;
  isReuse?: boolean;
  onClick: () => void;
  onDelete?: (event: SyntheticEvent) => void;
}

export const DetailsCard = memo<DetailsCardProps>(
  ({ image, title, name, count, isInit, isReuse, onClick, onDelete }) => (
    <div
      className={cn(PLATE_CLASSLIST.base, isInit && PLATE_CLASSLIST.pointer)}
      onClick={onClick}
    >
      <Image
        src={image}
        width={56}
        height={56}
        priority
        alt=""
        className="aspect-square size-14 rounded-sm bg-body object-contain"
      />

      <div className="flex flex-col">
        <span className="text-xs text-foreground/50">{title}</span>
        <div className="inline-flex items-center gap-2 text-base/5 font-medium">
          <span>{name}</span>
          {count ? (
            <div className="flex items-center gap-1 rounded-full bg-regular px-1.5 py-0.5">
              <Icon icon="photo_camera" size={4} />
              {count}
            </div>
          ) : null}
        </div>
      </div>

      {/* Если isReuse - показываем кнопку с корзиной */}
      {isReuse && (
        <Button
          variant="light"
          radius="full"
          size="md"
          onClick={onDelete}
          className="absolute top-4 right-2"
        >
          <Icon icon="delete" />
        </Button>
      )}

      {/* Если isInit и НЕ isReuse - показываем кнопку c настройкой */}
      {isInit && !isReuse && (
        <div
          className={cn(
            PLATE_CLASSLIST.button,
            "flex gap-1",
            "hide",
            "sm:flex",
          )}
        >
          <Button variant="light" radius="full" size="md">
            <Icon icon="tune" />
          </Button>

          {/* Для позы передаем onDelete - показываем кнопку c настройкой */}
          {onDelete && (
            <Button variant="light" radius="full" size="md" onClick={onDelete}>
              <Icon icon="delete" />
            </Button>
          )}
        </div>
      )}
    </div>
  ),
);

DetailsCard.displayName = "DetailsCard";
